import clsx from 'clsx'

import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'

import type { StaticField } from '../../Views/types'
import type { QuickLinksSource } from '../types'

interface Props {
  source: QuickLinksSource
  field: StaticField
  highlighted: boolean
  mediaUrl: string
}
export const ListImage = ({ source, field, highlighted, mediaUrl }: Props) => {
  return (
    <div className="shrink-0">
      <Avatar
        size={field.settings?.avatarSize ?? 'lg'}
        src={mediaUrl}
        name={source.title}
        rounded="md"
        className={clsx(
          highlighted && 'ring-2 ring-offset-surface ring-focused',
        )}
      />
    </div>
  )
}
